// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "create-claim";

export const createClaimResponseSchema = z
  .object({
    id: z.string(),
  })
  .strict();

export const createClaimParamsSchema = z
  .object({
    submittedTo: z.string().nullable().optional(),
    loadId: z.string(),
    claimAmount: z.number(),
    message: z.string(),
    tempId: z.string().optional(),
  })
  .strict();




export type CreateClaimResponse = z.infer<typeof createClaimResponseSchema>;

export type CreateClaimParams = z.infer<typeof createClaimParamsSchema>;




// receiver/create-claim endpoint
export function createClaim(
  params: z.input<typeof createClaimParamsSchema>
): Promise<CreateClaimResponse> {
  return requestHandler(
    "receiver/create-claim",
    params,
    createClaimResponseSchema,
  );
}

